import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  pure: false
})
export class HighlightPipe implements PipeTransform {
  transform(text: string, search: string): string {
    if (!search || !text) {
      return text;
    }
    // Escapa caracteres especiais para regex
    const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedSearch, 'gi');
    // Substitui o termo por <span class="highlight-busca">...</span>
    return text.replace(regex, match => `<span class="highlight-busca">${match}</span>`);
  }
} 